<div><canvas baseChart [data]="stages.data" [labels]="stages.labels" [colors]="chartColors" [options]="chartOptions" chartType="pie" *ngIf="isReady"></canvas></div>
